@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_560_531_181)
public val Res.string.work_hours_error_in_future: StringResource by lazy {
      StringResource("string:work_hours_error_in_future", "work_hours_error_in_future", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382251, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543687, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351294, 78),
      ))
    }

@delegate:ResourceContentHash(898_041_380)
public val Res.string.work_hours_error_not_worked: StringResource by lazy {
      StringResource("string:work_hours_error_not_worked", "work_hours_error_not_worked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382338, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543806, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351373, 87),
      ))
    }

@delegate:ResourceContentHash(-274_179_891)
public val Res.string.work_hours_error_not_yours: StringResource by lazy {
      StringResource("string:work_hours_error_not_yours", "work_hours_error_not_yours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382438, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 543934, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351461, 66),
      ))
    }

@delegate:ResourceContentHash(-303_292_206)
public val Res.string.work_hours_error_outside_window: StringResource by lazy {
      StringResource("string:work_hours_error_outside_window", "work_hours_error_outside_window", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382509, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 544009, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351528, 115),
      ))
    }

@delegate:ResourceContentHash(-1_726_191_521)
public val Res.string.work_hours_error_self_entry_off: StringResource by lazy {
      StringResource("string:work_hours_error_self_entry_off", "work_hours_error_self_entry_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382637, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 544169, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351644, 119),
      ))
    }

@delegate:ResourceContentHash(-1_129_836_233)
public val Res.string.work_hours_locked: StringResource by lazy {
      StringResource("string:work_hours_locked", "work_hours_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382761, 113),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 544349, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351764, 93),
      ))
    }

@delegate:ResourceContentHash(546_109_141)
public val Res.string.work_hours_next_day: StringResource by lazy {
      StringResource("string:work_hours_next_day", "work_hours_next_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382875, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 544503, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351858, 39),
      ))
    }

@delegate:ResourceContentHash(-501_534_175)
public val Res.string.work_hours_not_clocked: StringResource by lazy {
      StringResource("string:work_hours_not_clocked", "work_hours_not_clocked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382927, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 544567, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351898, 46),
      ))
    }

@delegate:ResourceContentHash(782_727_134)
public val Res.string.work_hours_note: StringResource by lazy {
      StringResource("string:work_hours_note", "work_hours_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 382986, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 544642, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351945, 127),
      ))
    }

@delegate:ResourceContentHash(-1_787_615_582)
public val Res.string.work_hours_open: StringResource by lazy {
      StringResource("string:work_hours_open", "work_hours_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383146, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 544886, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352073, 43),
      ))
    }

@delegate:ResourceContentHash(889_443_237)
public val Res.string.work_hours_plan: StringResource by lazy {
      StringResource("string:work_hours_plan", "work_hours_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383198, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 544966, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352117, 35),
      ))
    }

@delegate:ResourceContentHash(-1_893_988_414)
public val Res.string.work_hours_previous_day: StringResource by lazy {
      StringResource("string:work_hours_previous_day", "work_hours_previous_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383242, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545026, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352153, 47),
      ))
    }

@delegate:ResourceContentHash(-188_092_966)
public val Res.string.work_hours_reported: StringResource by lazy {
      StringResource("string:work_hours_reported", "work_hours_reported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383298, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545098, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352201, 67),
      ))
    }

@delegate:ResourceContentHash(342_635_674)
public val Res.string.work_hours_status_confirmed: StringResource by lazy {
      StringResource("string:work_hours_status_confirmed", "work_hours_status_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383370, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545182, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352269, 47),
      ))
    }

@delegate:ResourceContentHash(922_285_477)
public val Res.string.work_hours_status_not_worked: StringResource by lazy {
      StringResource("string:work_hours_status_not_worked", "work_hours_status_not_worked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383422, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545250, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352317, 52),
      ))
    }

@delegate:ResourceContentHash(-951_972_225)
public val Res.string.work_hours_status_not_yet: StringResource by lazy {
      StringResource("string:work_hours_status_not_yet", "work_hours_status_not_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383487, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545327, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352370, 49),
      ))
    }

@delegate:ResourceContentHash(1_035_051_900)
public val Res.string.work_hours_status_reported: StringResource by lazy {
      StringResource("string:work_hours_status_reported", "work_hours_status_reported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383565, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545417, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352420, 66),
      ))
    }

@delegate:ResourceContentHash(-877_688_245)
public val Res.string.work_hours_status_to_confirm: StringResource by lazy {
      StringResource("string:work_hours_status_to_confirm", "work_hours_status_to_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383636, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545504, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352487, 52),
      ))
    }

@delegate:ResourceContentHash(-1_779_073_079)
public val Res.string.work_hours_status_to_decide: StringResource by lazy {
      StringResource("string:work_hours_status_to_decide", "work_hours_status_to_decide", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383693, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545581, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352540, 75),
      ))
    }

@delegate:ResourceContentHash(-1_256_997_613)
public val Res.string.work_hours_title: StringResource by lazy {
      StringResource("string:work_hours_title", "work_hours_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383765, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545665, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352616, 40),
      ))
    }

@delegate:ResourceContentHash(-1_585_512_904)
public val Res.string.work_hours_who_worked: StringResource by lazy {
      StringResource("string:work_hours_who_worked", "work_hours_who_worked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383810, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545726, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352657, 65),
      ))
    }

@delegate:ResourceContentHash(1_811_000_372)
public val Res.string.work_kind_event: StringResource by lazy {
      StringResource("string:work_kind_event", "work_kind_event", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383896, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545824, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352723, 63),
      ))
    }

@delegate:ResourceContentHash(646_146_219)
public val Res.string.work_kind_overtime: StringResource by lazy {
      StringResource("string:work_kind_overtime", "work_kind_overtime", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 383980, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 545952, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352787, 38),
      ))
    }

@delegate:ResourceContentHash(-397_799_606)
public val Res.string.work_kind_remote: StringResource by lazy {
      StringResource("string:work_kind_remote", "work_kind_remote", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384023, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546031, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352826, 40),
      ))
    }

@delegate:ResourceContentHash(1_063_749_081)
public val Res.string.workplace: StringResource by lazy {
      StringResource("string:workplace", "workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 386408, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 549388, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 355015, 29),
      ))
    }

@delegate:ResourceContentHash(810_754_590)
public val Res.string.workplace_groups_add: StringResource by lazy {
      StringResource("string:workplace_groups_add", "workplace_groups_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384064, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546100, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352867, 40),
      ))
    }

@delegate:ResourceContentHash(324_278_179)
public val Res.string.workplace_groups_default_name: StringResource by lazy {
      StringResource("string:workplace_groups_default_name", "workplace_groups_default_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384109, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546161, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352908, 57),
      ))
    }

@delegate:ResourceContentHash(-735_088_335)
public val Res.string.workplace_groups_delete_confirm: StringResource by lazy {
      StringResource("string:workplace_groups_delete_confirm", "workplace_groups_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384171, 183),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546227, 255),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352966, 155),
      ))
    }

@delegate:ResourceContentHash(1_821_618_505)
public val Res.string.workplace_groups_empty_group: StringResource by lazy {
      StringResource("string:workplace_groups_empty_group", "workplace_groups_empty_group", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384355, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546483, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353122, 80),
      ))
    }

@delegate:ResourceContentHash(1_088_052_496)
public val Res.string.workplace_groups_error_name: StringResource by lazy {
      StringResource("string:workplace_groups_error_name", "workplace_groups_error_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384533, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546729, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353296, 67),
      ))
    }

@delegate:ResourceContentHash(1_273_773_398)
public val Res.string.workplace_groups_error_name_long: StringResource by lazy {
      StringResource("string:workplace_groups_error_name_long", "workplace_groups_error_name_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384440, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546592, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353203, 92),
      ))
    }

@delegate:ResourceContentHash(-1_745_578_292)
public val Res.string.workplace_groups_error_not_owned: StringResource by lazy {
      StringResource("string:workplace_groups_error_not_owned", "workplace_groups_error_not_owned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384597, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546809, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353364, 92),
      ))
    }

@delegate:ResourceContentHash(1_964_630_716)
public val Res.string.workplace_groups_error_too_many: StringResource by lazy {
      StringResource("string:workplace_groups_error_too_many", "workplace_groups_error_too_many", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384726, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 546942, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353457, 91),
      ))
    }

@delegate:ResourceContentHash(1_001_545_725)
public val Res.string.workplace_groups_error_two_groups: StringResource by lazy {
      StringResource("string:workplace_groups_error_two_groups", "workplace_groups_error_two_groups", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384818, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 547078, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353549, 93),
      ))
    }

@delegate:ResourceContentHash(1_087_880_868)
public val Res.string.workplace_groups_intro: StringResource by lazy {
      StringResource("string:workplace_groups_intro", "workplace_groups_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 384920, 250),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 547224, 418),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353643, 238),
      ))
    }

@delegate:ResourceContentHash(-141_393_901)
public val Res.string.workplace_groups_manage: StringResource by lazy {
      StringResource("string:workplace_groups_manage", "workplace_groups_manage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385171, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 547643, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353882, 51),
      ))
    }

@delegate:ResourceContentHash(2_020_549_384)
public val Res.string.workplace_groups_name: StringResource by lazy {
      StringResource("string:workplace_groups_name", "workplace_groups_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385294, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 547802, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353997, 45),
      ))
    }

@delegate:ResourceContentHash(983_824_113)
public val Res.string.workplace_groups_name_hint: StringResource by lazy {
      StringResource("string:workplace_groups_name_hint", "workplace_groups_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385227, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 547719, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 353934, 62),
      ))
    }

@delegate:ResourceContentHash(1_791_575_580)
public val Res.string.workplace_groups_new_title: StringResource by lazy {
      StringResource("string:workplace_groups_new_title", "workplace_groups_new_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385340, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 547860, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354043, 46),
      ))
    }

@delegate:ResourceContentHash(-337_141_971)
public val Res.string.workplace_groups_no_group: StringResource by lazy {
      StringResource("string:workplace_groups_no_group", "workplace_groups_no_group", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385391, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 547923, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354090, 45),
      ))
    }

@delegate:ResourceContentHash(-207_043_994)
public val Res.string.workplace_groups_profile_intro: StringResource by lazy {
      StringResource("string:workplace_groups_profile_intro", "workplace_groups_profile_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385437, 142),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 547981, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354136, 110),
      ))
    }

@delegate:ResourceContentHash(386_227_872)
public val Res.string.workplace_groups_rename_title: StringResource by lazy {
      StringResource("string:workplace_groups_rename_title", "workplace_groups_rename_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385580, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 548168, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354247, 53),
      ))
    }

@delegate:ResourceContentHash(2_104_092_037)
public val Res.string.workplace_groups_saved: StringResource by lazy {
      StringResource("string:workplace_groups_saved", "workplace_groups_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385646, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 548258, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354301, 46),
      ))
    }

@delegate:ResourceContentHash(-465_161_900)
public val Res.string.workplace_groups_title: StringResource by lazy {
      StringResource("string:workplace_groups_title", "workplace_groups_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385697, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 548329, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354348, 54),
      ))
    }

@delegate:ResourceContentHash(720_402_684)
public val Res.string.workplace_groups_ungrouped: StringResource by lazy {
      StringResource("string:workplace_groups_ungrouped", "workplace_groups_ungrouped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385880, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 548592, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354531, 54),
      ))
    }

@delegate:ResourceContentHash(1_273_002_785)
public val Res.string.workplace_groups_ungrouped_hint: StringResource by lazy {
      StringResource("string:workplace_groups_ungrouped_hint", "workplace_groups_ungrouped_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385744, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 548396, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354403, 127),
      ))
    }

@delegate:ResourceContentHash(-263_402_252)
public val Res.string.workplace_work_hours_self_entry: StringResource by lazy {
      StringResource("string:workplace_work_hours_self_entry", "workplace_work_hours_self_entry", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 386324, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 549272, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354931, 83),
      ))
    }

@delegate:ResourceContentHash(881_589_886)
public val Res.string.workplace_work_hours_self_entry_hint: StringResource by lazy {
      StringResource("string:workplace_work_hours_self_entry_hint", "workplace_work_hours_self_entry_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 385931, 392),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 548659, 612),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354586, 344),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString46Resources(map: MutableMap<String, StringResource>) {
  map.put("work_hours_error_in_future", Res.string.work_hours_error_in_future)
  map.put("work_hours_error_not_worked", Res.string.work_hours_error_not_worked)
  map.put("work_hours_error_not_yours", Res.string.work_hours_error_not_yours)
  map.put("work_hours_error_outside_window", Res.string.work_hours_error_outside_window)
  map.put("work_hours_error_self_entry_off", Res.string.work_hours_error_self_entry_off)
  map.put("work_hours_locked", Res.string.work_hours_locked)
  map.put("work_hours_next_day", Res.string.work_hours_next_day)
  map.put("work_hours_not_clocked", Res.string.work_hours_not_clocked)
  map.put("work_hours_note", Res.string.work_hours_note)
  map.put("work_hours_open", Res.string.work_hours_open)
  map.put("work_hours_plan", Res.string.work_hours_plan)
  map.put("work_hours_previous_day", Res.string.work_hours_previous_day)
  map.put("work_hours_reported", Res.string.work_hours_reported)
  map.put("work_hours_status_confirmed", Res.string.work_hours_status_confirmed)
  map.put("work_hours_status_not_worked", Res.string.work_hours_status_not_worked)
  map.put("work_hours_status_not_yet", Res.string.work_hours_status_not_yet)
  map.put("work_hours_status_reported", Res.string.work_hours_status_reported)
  map.put("work_hours_status_to_confirm", Res.string.work_hours_status_to_confirm)
  map.put("work_hours_status_to_decide", Res.string.work_hours_status_to_decide)
  map.put("work_hours_title", Res.string.work_hours_title)
  map.put("work_hours_who_worked", Res.string.work_hours_who_worked)
  map.put("work_kind_event", Res.string.work_kind_event)
  map.put("work_kind_overtime", Res.string.work_kind_overtime)
  map.put("work_kind_remote", Res.string.work_kind_remote)
  map.put("workplace", Res.string.workplace)
  map.put("workplace_groups_add", Res.string.workplace_groups_add)
  map.put("workplace_groups_default_name", Res.string.workplace_groups_default_name)
  map.put("workplace_groups_delete_confirm", Res.string.workplace_groups_delete_confirm)
  map.put("workplace_groups_empty_group", Res.string.workplace_groups_empty_group)
  map.put("workplace_groups_error_name", Res.string.workplace_groups_error_name)
  map.put("workplace_groups_error_name_long", Res.string.workplace_groups_error_name_long)
  map.put("workplace_groups_error_not_owned", Res.string.workplace_groups_error_not_owned)
  map.put("workplace_groups_error_too_many", Res.string.workplace_groups_error_too_many)
  map.put("workplace_groups_error_two_groups", Res.string.workplace_groups_error_two_groups)
  map.put("workplace_groups_intro", Res.string.workplace_groups_intro)
  map.put("workplace_groups_manage", Res.string.workplace_groups_manage)
  map.put("workplace_groups_name", Res.string.workplace_groups_name)
  map.put("workplace_groups_name_hint", Res.string.workplace_groups_name_hint)
  map.put("workplace_groups_new_title", Res.string.workplace_groups_new_title)
  map.put("workplace_groups_no_group", Res.string.workplace_groups_no_group)
  map.put("workplace_groups_profile_intro", Res.string.workplace_groups_profile_intro)
  map.put("workplace_groups_rename_title", Res.string.workplace_groups_rename_title)
  map.put("workplace_groups_saved", Res.string.workplace_groups_saved)
  map.put("workplace_groups_title", Res.string.workplace_groups_title)
  map.put("workplace_groups_ungrouped", Res.string.workplace_groups_ungrouped)
  map.put("workplace_groups_ungrouped_hint", Res.string.workplace_groups_ungrouped_hint)
  map.put("workplace_work_hours_self_entry", Res.string.workplace_work_hours_self_entry)
  map.put("workplace_work_hours_self_entry_hint", Res.string.workplace_work_hours_self_entry_hint)
}
